import React from "react";
import { Container, Accordion } from "react-bootstrap";
import "./FaqSection.css";
import Common_Title from "../../common_components/common_title/Common_Title";

const faqData = [
  {
    id: "0",
    question: "How does the Featured Profile service boost my job search?",
    answer:
      "The Featured Profile service allows you to stand out in the competitive job market by ranking your profile higher in search results and highlighting your profile as an active job seeker. This service can increase your visibility by 10x and give you an edge in your job search.",
  },
  {
    id: "1",
    question: "How can professional resume writing benefit my job search?",
    answer:
      "Professional resume writing helps you craft a compelling professional story, optimizing your layout with strategic keywords to ensure you rank higher in recruiter searches and pass ATS filters seamlessly.",
  },
  {
    id: "2",
    question:
      "Can the Profile Highlighter feature help me get more job opportunities?",
    answer:
      "Yes, by adding a visual highlight to your profile and tagging you explicitly as an active job seeker, it draws immediate recruiter attention to your applications.",
  },
  {
    id: "3",
    question: "What does the LinkedIn Profile Makeover service entail?",
    answer:
      "It includes a complete revamp of your headline, summary, work history, and accomplishments to turn your profile into a magnet for inbound recruiter opportunities.",
  },
  {
    id: "4",
    question:
      "What features are included in the Premium Resume Builder service?",
    answer:
      "You get full access to over 15 ATS-friendly templates, 400+ pre-written industry samples, and an interactive builder to customize your resume within minutes.",
  },
];

const FaqSection = () => {
  return (
    <div className="faq-section-parent">
      <Container>
        {/* Section Header Title */}
        <div className="title_div mb-4">
          <Common_Title title="Frequently Asked   " subTitle="Questions" />
        </div>
        {/* React Bootstrap Accordion */}
        <Accordion defaultActiveKey="0" flush className="faq-accordion-wrapper">
          {faqData.map((item) => (
            <Accordion.Item
              key={item.id}
              eventKey={item.id}
              className="faq-item"
            >
              <Accordion.Header className="faq-header">
                {item.question}
              </Accordion.Header>
              <Accordion.Body className="faq-body">
                {item.answer}
              </Accordion.Body>
            </Accordion.Item>
          ))}
        </Accordion>
      </Container>
    </div>
  );
};

export default FaqSection;
